import { type ReactNode, memo, useCallback } from 'react';
import { Button, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight, IconCheck } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import type { AcceptInvitationResponse } from '@/types/api/responses';
import styles from '../InvitationPage.module.css';

interface InvitationSuccessContentProps {
  acceptResult: AcceptInvitationResponse;
}

const CHECK_ICON_SIZE = 32;
const ARROW_ICON_SIZE = 20;

export const InvitationSuccessContent = memo(function InvitationSuccessContent({
  acceptResult,
}: InvitationSuccessContentProps): ReactNode {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoToDashboard = useCallback(() => {
    navigate(`/w/${acceptResult.workspaceShortId}/dashboard`);
  }, [navigate, acceptResult.workspaceShortId]);

  return (
    <div className={styles.successWrapper}>
      <Stack align="center" gap="md">
        <div className={styles.successIcon}>
          <IconCheck size={CHECK_ICON_SIZE} />
        </div>
        <Title order={2} ta="center">
          {t('invitation.success.title')}
        </Title>
        <Text c="dimmed" ta="center" size="md">
          {t('invitation.success.description')}
        </Text>
        <Text c="dimmed" ta="center" size="sm">
          {t('invitation.success.joinedWorkspace', {
            workspaceName: acceptResult.workspaceName,
          })}
        </Text>
        <Button
          size="lg"
          rightSection={<IconArrowRight size={ARROW_ICON_SIZE} />}
          onClick={handleGoToDashboard}
        >
          {t('invitation.success.goToDashboard')}
        </Button>
      </Stack>
    </div>
  );
});
